import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-body p-4 text-center" }
const _hoisted_2 = {
  key: 0,
  class: "m-auto m-1230",
  style: {"max-width":"550px"}
}
const _hoisted_3 = { class: "card bg-white border-0 rounded-10 mb-4 text-center" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "mb-4 text-danger" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "d-flex justify-content-center align-items-center vh-100" }
const _hoisted_8 = {
  class: "card bg-white border-0 rounded-10 shadow",
  style: {"width":"400px"}
}
const _hoisted_9 = { class: "card-body p-4 text-center" }
const _hoisted_10 = { class: "mb-3 text-start" }
const _hoisted_11 = { class: "input-error" }
const _hoisted_12 = { class: "mb-3 text-start" }
const _hoisted_13 = { class: "input-error" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "text-danger mt-2"
}
const _hoisted_16 = {
  key: 2,
  class: "m-auto m-1230",
  style: {"max-width":"550px"}
}
const _hoisted_17 = { class: "card bg-white border-0 rounded-10 mb-4 text-center" }
const _hoisted_18 = { class: "card-body p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.viewState === 'invalid')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "fs-20 fw-semibold mb-2 text-danger" }, "Error !", -1 /* HOISTED */)),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.message), 1 /* TEXT */),
                _createVNode(_component_RouterLink, {
                  to: "/login",
                  class: "btn btn-link w-100 mt-2"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" Ir Login ")
                  ])),
                  _: 1 /* STABLE */
                })
              ])
            ])
          ]))
        : (_ctx.viewState === 'valid')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mb-3" }, [
                      _createElementVNode("img", {
                        src: "/favicon-32x32.png",
                        class: "rounded-3",
                        alt: "logo"
                      })
                    ], -1 /* HOISTED */)),
                    _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "fs-20 fw-semibold mb-2" }, "Recuperar contraseña", -1 /* HOISTED */)),
                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mb-4" }, "Ingresa tu nueva contraseña", -1 /* HOISTED */)),
                    _createElementVNode("form", {
                      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label" }, "Nueva Contraseña", -1 /* HOISTED */)),
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userPasswordRecover.newPassword) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            _ctx.userPasswordRecover.newPassword,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.errors.newPassword), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label" }, "Confirmar contraseña", -1 /* HOISTED */)),
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userPasswordRecover.confirmPassword) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            _ctx.userPasswordRecover.confirmPassword,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.errors.confirmPassword), 1 /* TEXT */)
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-primary w-100",
                        disabled: _ctx.isLoading
                      }, " Confirmar ", 8 /* PROPS */, _hoisted_14)
                    ], 32 /* NEED_HYDRATION */),
                    (_ctx.message)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.message), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_RouterLink, {
                      to: "/login",
                      class: "btn btn-link w-100 mt-2"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" Ir Login ")
                      ])),
                      _: 1 /* STABLE */
                    })
                  ])
                ])
              ])
            ]))
          : (_ctx.viewState === 'success')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "fs-20 fw-semibold mb-2 text-success" }, "Éxito !", -1 /* HOISTED */)),
                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "mb-4 text-success" }, "Tu contraseña ha sido actualizada", -1 /* HOISTED */)),
                    _createVNode(_component_RouterLink, {
                      to: "/login",
                      class: "btn btn-link w-100 mt-2"
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" Ir Login ")
                      ])),
                      _: 1 /* STABLE */
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}